import React from 'react'

/** Table with sticky header, zebra rows, consistent spacing. */
export default function DataTable({ children, className = '' }) {
  return (
    <div className={`overflow-x-auto rounded-xl border border-white/10 ${className}`}>
      <table className="w-full min-w-[640px] border-collapse text-sm">
        {children}
      </table>
    </div>
  )
}

export function DataTableHead({ children }) {
  return (
    <thead className="sticky top-0 z-10 border-b border-white/10 bg-black/60 backdrop-blur">
      <tr className="text-left text-xs font-medium uppercase tracking-wider text-white/60">
        {children}
      </tr>
    </thead>
  )
}

export function DataTableBody({ children }) {
  return <tbody className="divide-y divide-white/5">{children}</tbody>
}

export function DataTableRow({ children, zebra = false, className = '' }) {
  return (
    <tr className={`transition-colors hover:bg-white/5 ${zebra ? 'bg-white/[0.02]' : ''} ${className}`}>
      {children}
    </tr>
  )
}

export function DataTableCell({ children, className = '', header = false }) {
  const Tag = header ? 'th' : 'td'
  return (
    <Tag
      className={`px-4 py-3 text-white/90 ${header ? 'font-medium text-white/70' : ''} ${className}`}
    >
      {children}
    </Tag>
  )
}
